'use client'
import { Spinner } from "@heroui/react"

const Component = () => <div><Spinner color='secondary' /></div>
export default Component
